import {
    URLAPI,
    REASON_MOVEMENT_PATH,
    REASON_MOVEMENT_CREATE_PATH,
    REASON_MOVEMENT_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_reason_movement: {
        data: [],

        status: 0,
        message: {},
    },

    _create_reason_movement: {
        data: {},
        status: 0,
        message: {},
    },
    _update_reason_movement: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_REASON_MOVEMENT = "GET_ALL_REASON_MOVEMENT";
export const CREATE_REASON_MOVEMENT = "CREATE_REASON_MOVEMENT";
export const UPDATE_REASON_MOVEMENT = "UPDATE_REASON_MOVEMENT";

export const reason_movement_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_REASON_MOVEMENT:
            return {
                ...state,
                _get_all_reason_movement: action.payload,
            };
        case CREATE_REASON_MOVEMENT:
            return {
                ...state,
                _create_reason_movement: action.payload,
            };
        case UPDATE_REASON_MOVEMENT:
            return {
                ...state,
                _update_reason_movement: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllReasonMovement = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${REASON_MOVEMENT_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_REASON_MOVEMENT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_REASON_MOVEMENT,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_REASON_MOVEMENT,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createReasonMovement = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${REASON_MOVEMENT_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_REASON_MOVEMENT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_REASON_MOVEMENT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_REASON_MOVEMENT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateReasonMovement = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${REASON_MOVEMENT_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_REASON_MOVEMENT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_REASON_MOVEMENT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_REASON_MOVEMENT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const clear_reason_movement = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
